import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';

export interface Props {
  url: string;
  title: string;
  imageSrc: string;
  alt?: string;
  buttonColor?: string;
  bgColor?: string;
}

function Card({ imageSrc, url, title, alt, buttonColor, bgColor }: Props) {
  return (
    <Wrapper bg={bgColor}>
      <ImageWrapper to={url}>
        <Image src={imageSrc} alt={alt} />
      </ImageWrapper>
      <TextButtonWrapper>
        <Text>{title}</Text>
        <StyledLink>{__('Viac')}</StyledLink>
      </TextButtonWrapper>
    </Wrapper>
  );
}

interface WrapperProps {
  bg?: string;
}

const Wrapper = styled(FlexCol)`
  margin-bottom: ${rem(16)};
  width: 100%;
  max-width: ${rem(360)};
  margin-right: ${rem(32)};
  border-radius: ${rem(4)};

  overflow: hidden;
  max-height: ${rem(450)};

  &:last-child {
    margin-right: 0;
  }

  ${({ theme }) => theme.mediab.l925`
     flex-flow: row;
     align-items: center;
     margin: 0;
     margin-bottom: ${rem(16)};
     max-width: initial;

     &:hover {
      transform: initial;
    }
  `}
`;

const ImageWrapper = styled(Link)`
  margin-right: ${rem(16)};
  width: 100%;

  ${({ theme }) => theme.mediab.l925`
    max-width: ${rem(80)}
  `}
`;

const Image = styled.img`
  width: 100%;
  max-height: ${rem(752)};
  margin-bottom: ${rem(24)};
  border-radius: 0 0 ${rem(32)} 0;
  transition: transform 0.25s ease;

  &:hover {
    transform: scale(1.05);
  }

  ${({ theme }) => theme.mediab.l925`
     margin-bottom: 0;
     width: ${rem(80)};
     height: ${rem(80)};
     border-radius: ${rem(2)}  0 0 ${rem(2)} ;
     object-fit: cover;
  `}
`;

const TextButtonWrapper = styled(FlexCol)`
  justify-content: space-between;
  height: 100%;
  max-height: 100%;

  ${({ theme }) => theme.mediab.l925`
     flex-flow: row;
     align-items: center;
     width: 100%;
  `}
`;

const Text = styled(TextP)`
  font-size: ${rem(30)};
  line-height: ${rem(30)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.secondary};
  text-transform: uppercase;
  text-align: center;
  font-weight: 500;
  padding: 0 ${rem(16)} ${rem(16)} ${rem(16)};

  ${({ theme }) => theme.mediab.l925`
     font-size: ${rem(18)};
     margin: 0;
  `}
`;

const StyledLink = styled(Link)`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.color.textPrimary};
  text-align: center;
  padding: 0 ${rem(16)} ${rem(16)} ${rem(16)};
  text-decoration: underline;
  font-weight: 700;
`;

export { Card };
